import {getOrder} from "../../js/axios";
import el from "element-ui/src/locale/lang/el";
import axios from 'axios'  //这里引入axios  mian无需再引
import Vue from "vue";    //引入Vue
Vue.prototype.$ajax = axios;  //修改ajax原型指向为 axios
import Qs from 'qs';
export default {
    name: 'order',
    data() {
        return {
            phone: false,
            yzCode: false,
            ifEdit: false,
            dateValue: '',
            tableData: [],
            pageCount: 1,
            pageNum: 0,

            value: '',
			appt_status: '0',
            showDate: '',
            tipStatus: "",
            tipText: "",
            alertShow: false,
			o_sn: '',
			nowMobile: '',
        }
    },

    mounted() {
		
        this.resizeChange();
        window.onresize = () => {
            return (() => {
                this.resizeChange()
            })();
        };
        let minDate = new Date();
        minDate.setDate(minDate.getDate() + 4);
        this.showDate = minDate;

		this.reportCommit(1);
        // addressList().then(res => {
        //     if (res.status == '1') {
        //         res.data.forEach(item => {
        //             item.name = item.name + "：" + item.address
        //         })
        //         this.areaBookinglist = res.data;
        //     }
        // })

    },
    methods: {
		resetPager(){
			this.pageCount = 1
			this.pageNum = 0
		},
        confirmDialog() {
            this.alertShow = false;
        },
        closeDialog() {
            this.alertShow = false;
            //把绑定的弹窗数组 设为false即可关闭弹窗
        },
		phoneMustNumber(value) {
			this.nowMobile = value.replace(/\D/g,'');
		},
		phoneMustNumber2(value) {
			this.o_sn = value.replace(/\D/g,'');
		},
        resizeChange() {
            let tableWidth = document.getElementsByClassName('el-table__body-wrapper')[0].offsetWidth;
        },

        handleCurrentChange(val) {
            this.pageNum = val;
            this.reportCommit(val);
        },
        reportCommit(val) {
			let data = {
				mobile: this.nowMobile,
				o_sn: this.o_sn,
			    page: val,
			    pagesize: 10
			};
			
			getOrder(data).then((res) => {
			    if (res.code == 200) {
					let result = JSON.parse(window.atob(res.data))
			        if (result.data != '') {
			            this.pageCount = parseInt(result.pager.count);
			
			            this.tableData = result.data;
						
			        } else {
						this.pageCount = 1
			            // this.alertShow = true;
			            // this.tipStatus = "查詢結果";
			            // this.tipText = "暂无数据";
			            this.tableData = result.data;
			        }
			
			    } else {
					this.resetPager()
					this.alertShow = true;
					this.tipStatus = "查詢失敗";
					this.tipText = res.msg;
				}
			})
        },
        closeEdit() {
            this.ifEdit = false;
            this.areaValue = '';
            this.dateEdit = '';
            this.timeEdit = '';
            this.editAreaID = 0;

        },
        getReport() {
			if(this.nowMobile.trim() != '' || this.o_sn != '') {
				this.reportCommit(1);
			}
        },
		handleReset() {
			this.nowMobile = '';
			this.o_sn = '';
			this.reportCommit(1);
		},
    }
}